module.exports = __webpack_public_path__ + "static/img/idream.b811c762.png";